
export default (urlParameters) => {
  return {
    storm_spaghetti_map: true
  }
}